import React from "react";
import Button from "../../../../../../_components/Button";
import { downaloadDANFE, getNFeBase64 } from "../../../../../../api/nfe";
import { getCookieByName } from "../../../../../../utils";
export default (props) => {
    const [loading, setLoading] = React.useState(false);

    let branchName = getCookieByName("branch_owner_name")

    function getNfeKey() {
        downaloadDANFE(props.nfe.id)
            .then((resp) => {
                console.log('resp.key', resp.key)
                sendToWhatsapp(resp.key)
                setLoading(false)
            })
            .catch(() => setLoading(false))


        setLoading(false)
    }

    function sendToWhatsapp(key) {
        setLoading(true)

        getNFeBase64({ key, return_type: 'link' })
            .then(data => {
                let numero = "55" + props.nfe.recipient_phone_number
                const dataLink = 'https://influen.cr/share-wpp-nfe'
                const message = `Olá. Boa notícia! A sua Nota Fiscal já se encontra disponível. ✅\n\nEssa é uma mensagem automática da Easygestor, sistema de gestão e documentos fiscais no Brasil\n\n📍Emitente: ${branchName}\n\nAbrir em pdf: ${data.pdf}\n\nAbrir em xml: ${data.xml}\n\nConheça mais sobre a Easygestor e emita notas grátis 🧾: ${dataLink}`
                const formatedMessage = encodeURIComponent(message)
                window.open(`https://api.whatsapp.com/send/?phone=${numero}?&text=${formatedMessage}`, "_blank")
            })
            .catch(() => { setLoading(false) })
    }

    return (
        <Button
            as="text"
            className="text-info mx-1"
            onClick={getNfeKey}
            disabled={loading}>
            <i className="fab fa-whatsapp" />
            <span className="ml-1">Enviar para Whatsapp do destinatário</span>
        </Button>
    );
};


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/SendNfeToWhatsapp/index.jsx